// Build the 5-series uPlot payload used by ElevationChart from measure samples.
export default function samplesToChartData(samples) {
    const elevationSamples = [[], [], [], [], []];
    let lastSampleType = null;

    if (!samples?.length) {
        elevationSamples[0].push(0, 1000);
        elevationSamples[1].push(null, null);
        elevationSamples[2].push(null, null);
        elevationSamples[3].push(0, 0);
        elevationSamples[4].push(null, null);
        return elevationSamples;
    }

    for (const sample of samples) {
        const height = sample?.height_msl;
        elevationSamples[0].push(sample.distance_along);

        if (!Number.isFinite(height)) {
            elevationSamples[1].push(null);
            elevationSamples[2].push(null);
            elevationSamples[3].push(0);
            elevationSamples[4].push(null);
            lastSampleType = null;
            continue;
        }

        if (height >= 0) {
            elevationSamples[1].push(height);
            elevationSamples[2].push(lastSampleType === 'water' ? height : null);
            lastSampleType = 'land';
        } else {
            elevationSamples[2].push(height);
            elevationSamples[1].push(lastSampleType === 'land' ? height : null);
            lastSampleType = 'water';
        }
        elevationSamples[3].push(0);
        elevationSamples[4].push(Math.min(0, height));
    }

    return elevationSamples;
}
